import { SIGNUP_TEXT } from "../../domain/constants/constants";
import { styles as s } from "../../styles/signupstyles";

type Props = {
  method: "email" | "phone";

  email: string;
  phone: string;

  setEmail: (value: string) => void;
  setPhone: (value: string) => void;
};

export default function ContactInput({
  method,
  email,
  phone,
  setEmail,
  setPhone,
}: Props) {
  return (
    <>
      <label className={s.label}>
        {method === "email"
          ? SIGNUP_TEXT.emailLabel
          : SIGNUP_TEXT.phoneLabel}
      </label>

      {method === "email" ? (
        <input
          type="email"
          className={s.input}
          placeholder={SIGNUP_TEXT.emailPlaceholder}
          value={email}
          maxLength={254}
          onChange={(e) => {
            const value = e.target.value
              .replace(/[^a-zA-Z0-9@._+-]/g, "")
              .replace(/\s/g, "");

            setEmail(value);
          }}
        />
      ) : (
        <div className={`${s.input} flex items-center gap-3`}>
          <span className="font-semibold text-[#13211B]">
            {SIGNUP_TEXT.countryCode}
          </span>

          <input
            type="tel"
            className="flex-1 bg-transparent outline-none"
            placeholder={SIGNUP_TEXT.phonePlaceholder}
            value={phone}
            maxLength={10}
            inputMode="numeric"
            onChange={(e) =>
              setPhone(
                e.target.value
                  .replace(/\D/g, "")
                  .slice(0, 10)
              )
            }
          />
        </div>
      )}

      <p className={s.hint}>
        {method === "email"
          ? SIGNUP_TEXT.emailHint
          : SIGNUP_TEXT.phoneHint}
      </p>
    </>
  );
}